import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth"
import { auth, firestore } from "../firebase"
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore"

// Mobile-Browser (vor allem iOS Safari / Chrome auf Android) blockieren
// `signInWithPopup` regelmäßig. Wir greifen dort direkt auf den
// Redirect-Flow zurück und nutzen Popup nur auf Desktop.
const isMobileLikeUA = () => {
  if (typeof navigator === "undefined") return false
  const ua = navigator.userAgent || ""
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(ua)) return true
  // iPadOS 13+ meldet sich als Desktop, hat aber Touch.
  if (
    /Macintosh/i.test(ua) &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1
  ) {
    return true
  }
  return false
}

const provisionUserDoc = async (user) => {
  const userDocRef = doc(firestore, "users", user.uid)
  const userDoc = await getDoc(userDocRef)
  if (userDoc.exists()) {
    await updateDoc(userDocRef, {
      email: user.email,
      lastLogin: serverTimestamp(),
    })
  } else {
    await setDoc(userDocRef, {
      email: user.email,
      createdAt: serverTimestamp(),
      lastLogin: serverTimestamp(),
      balance: 0,
      plan: "free",
    })
  }
}

// Wird beim App-Start einmal aufgerufen, um nach einem Redirect-Login
// das Firestore-User-Dokument anzulegen / zu aktualisieren.
export const finalizeRedirectSignIn = async (setError) => {
  try {
    const result = await getRedirectResult(auth)
    if (result?.user) {
      await provisionUserDoc(result.user)
    }
  } catch (error) {
    console.error("Error finalizing redirect sign-in:", error?.message || error)
    if (typeof setError === "function") setError(error?.message || String(error))
  }
}

export const handleGoogleSignIn = async (setError) => {
  const provider = new GoogleAuthProvider()

  // Auf Mobile direkt Redirect — Popup ist dort unzuverlässig.
  if (isMobileLikeUA()) {
    try {
      await signInWithRedirect(auth, provider)
    } catch (error) {
      console.error("Error during Google redirect sign-in:", error?.message || error)
      if (typeof setError === "function") setError(error?.message || String(error))
    }
    return
  }

  try {
    const result = await signInWithPopup(auth, provider)
    await provisionUserDoc(result.user)
    console.log("User signed in:", result.user.email)
  } catch (error) {
    const code = error?.code || ""
    // Popup wurde geblockt / vom User geschlossen / parallel geöffnet:
    // sauber auf Redirect umschalten.
    if (
      code === "auth/popup-blocked" ||
      code === "auth/popup-closed-by-user" ||
      code === "auth/cancelled-popup-request" ||
      code === "auth/operation-not-supported-in-this-environment"
    ) {
      try {
        await signInWithRedirect(auth, provider)
        return
      } catch (redirectError) {
        console.error(
          "Error during Google redirect sign-in:",
          redirectError?.message || redirectError
        )
        if (typeof setError === "function") {
          setError(redirectError?.message || String(redirectError))
        }
        return
      }
    }
    console.error("Error during Google sign-in:", error?.message || error)
    if (typeof setError === "function") setError(error?.message || String(error))
  }
}
